/**
 * Created by ievgenb on 9/28/2016.
 */
define(function(require, exports, module) {
    'use strict';
    const Form = require('class/form.class');
    const serverUtil = require('util/server.util');
    const BingoPromocodeModel = require('replacers/bingo-promocode/bingo.promocode.model');
    const userValidationConfig = require('modules/user/user.validation.config');
    const BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        model: new BingoPromocodeModel(),

        form: null,

        accessRules: {
            allow: ['user']
        },

        events: {
            'submit .fn-form-bingo-promocode': 'submitAction',
            'change .fn-bingo-promo-code': 'set'
        },

        successVFmessages: [
            'playtech.mobile.system.promocode.send-code-success',
            'playtech.mobile.system.promocode.send-code-success1',
            'playtech.mobile.system.promocode.send-code-success2',
            'playtech.mobile.system.promocode.send-code-success3'
        ],

        successIMSmessages:[
            'playtech.mobile.system.promocode.atLeastOneBonusGiven',
            'playtech.mobile.system.promocode.info.tryWithDeposit',
            'playtech.mobile.system.promocode.info.noBonus'
        ],

        set: function(e) {
            this.model.set('promotionCode', e.currentTarget.value);
        },

        submitAction: function(e) {
            e.preventDefault();

            this.form.validate().done(function(data, form) {
                form.showLoading();
                this.model.registerPromocode()
                    .done(this._handleSuccessResponse.bind(this))
                    .fail(this._handleErrorResponse.bind(this))
                    .always(this._alwaysOnResponse.bind(this));
            }.bind(this));
        },

        _handleSuccessResponse: function(response) {
            var message;
            var variant;

            if(response.data && response.data.result) {
                message = this.successIMSmessages[response.data.result - 1];
                variant = response.data.result === 1 || response.data.result === 2
                    ? this.toastVariants.SUCCESS
                    : this.toastVariants.INFO;
            } else {
                message = response.data && response.data.message ? response.data.message : this.successVFmessages[0];
                variant = this.toastVariants.INFO;
            }

            this.showInfo({
                content: this.translate(message),
                variant
            });
        },

        _handleErrorResponse: function(response) {
            this.showInfo({
                content: response.ID === -1
                    ? serverUtil.getErrorMessage(response)
                    : this.translate('playtech.mobile.system.send-code-error.' + response.ID), // 31067, 89521, 89524
                variant: this.toastVariants.INFO
            });
        },

        _alwaysOnResponse: function() {
            this.form.hideLoading();
        },

        render: function() {

            this.$el.html(this.tmpl('bingo-promocode'));

            this.form = new Form(this.$el.find('.fn-form-bingo-promocode'), {
                validationConfig: userValidationConfig()
            });

            return this;
        }
    }, {
        nameOfReplacers: [
            'BINGO_PROMOCODE'
        ]
    });
});
